import { DeliveryAddress, DeliveryAddressResponse, RegisterDeliveryAddressRequest, UpdateDeliveryAddressRequest } from "../model/delivery-address";
import { apiSlice } from "../stores/base/api-slice";

const deliveryAddressEndpoints = apiSlice.injectEndpoints({
	endpoints: builder => ({
		getDeliveryAddress: builder.query<Array<DeliveryAddress>, void>({
			providesTags: ["DeliveryAddress"],
			query: () => ({
				url: "/delivery-address",
				method: "GET",
			}),
		}),
		createDeliveryAddress: builder.mutation<string, DeliveryAddress>({
			invalidatesTags: ["DeliveryAddress"],
			query: data => ({
				url: "/delivery-address",
				method: "POST",
				body: data,
			}),
		}),
		updateDeliveryAddress: builder.mutation<string, DeliveryAddress>({
			invalidatesTags: ["DeliveryAddress"],
			query: data => ({
				url: "/delivery-address",
				method: "PUT",
				body: data,
			}),
		}),
		deleteDeliveryAddress: builder.mutation<void, string>({
			invalidatesTags: ["DeliveryAddress"],
			query: id => ({
				url: "/delivery-address",
				method: "DELETE",
				body: {
					deliveryAddressId: id,
				},
			}),
		}),
		getDeliveryAddresses: builder.query<DeliveryAddressResponse[], void>({
			providesTags: ["DeliveryAddress"],
			query: () => ({
				url: "/order/delivery-address",
				method: "GET",
			}),
		}),
		registerDeliveryAddress: builder.mutation<string, RegisterDeliveryAddressRequest>({
			invalidatesTags: ["DeliveryAddress"],
			query: data => ({
				url: "/order/delivery-address",
				method: "POST",
				body: data,
			}),
		}),
		updateDeliveryAddressInfo: builder.mutation<string, UpdateDeliveryAddressRequest>({
			invalidatesTags: ["DeliveryAddress"],
			query: data => ({
				url: "/order/delivery-address",
				method: "PUT",
				body: data,
			}),
		}),
	}),
});

export const { useLazyGetDeliveryAddressQuery, useCreateDeliveryAddressMutation, useUpdateDeliveryAddressMutation, useDeleteDeliveryAddressMutation, useLazyGetDeliveryAddressesQuery, useRegisterDeliveryAddressMutation, useUpdateDeliveryAddressInfoMutation } =
	deliveryAddressEndpoints;
